// extracted by mini-css-extract-plugin
module.exports = {"varSpDown3":"0.25rem","container":"container--052f4","title":"title--89f9a","paragraph":"paragraph--0eeb7","img":"img--2139d"};